<td>
  <span class="flex gap-2 align-items-center"
    ><i class="fas fa-palette"></i> {{ item.name }}</span
  >
</td>
@if (activeUserStore.canAccessEntityAdder()) {
  <td>
    <span class="flex gap-2">
      <a
        pButton
        class="ml-auto p-button-xs"
        (click)="closeParent()"
        [routerLink]="[{ outlets: { bearbeiten: ['farbsets', item._id] } }]"
        [rounded]="true"
        icon="fas fa-pen"></a>
    </span>
  </td>
}
